export const MULTIPLE_CHOICE_LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
export const MIN_NUMBER_OF_OPTIONS = 2;
export const MAX_NUMBER_OF_OPTIONS = 8;
